<template>
  <div class="row orders">
    <div class="col-lg-3 col-md-4 col-xs-4">
      <div class="row">
        <div class="fixed" :style="{height: windowHeight - pageTopHeight + 'px'}">
          <div class="table-top" ref="tableTop">
            <el-row>
              <el-col>
                <el-input @input="search" v-model="searchQuery" :placeholder="$t('general.search')" class="sm-search icon-search"></el-input>
                <el-dropdown type="default" class="dropdown-sm" :hide-on-click="false">
                  <el-button type="default" class="filter-btn">
                    <img src="/static/img/icons/filter.png">
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      {{$t('orders.status')}}
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox-group v-model="requestFilters[0].value">
                        <template v-for="(sts, key) in statuses" >
                          <template v-if="key !== 'DRAFT'" >
                            <el-checkbox
                                          :label="key"
                                          :value="key"
                                          :key="key"> {{$t('ordersStatus.' + key)}}
                            </el-checkbox>
                            <br/>
                          </template>
                        </template>
                      </el-checkbox-group>
                    </el-dropdown-item>
                    <template v-if="showLocations">
                      <el-dropdown-item divided>{{$t('orders.location')}}</el-dropdown-item>
                      <el-dropdown-item>
                        <el-checkbox-group v-model="locationFilter" @input="updateCookie">
                          <template v-for="(loc, key) in locations" >
                            <el-checkbox  :label="loc.id"
                                          :value="loc.id"
                                          :key="loc.id"
                                          > {{loc.name}}
                            </el-checkbox>
                            <br/>
                          </template>
                        </el-checkbox-group>
                      </el-dropdown-item>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
                <div class="pad-to-10 text-bold">
                  <template v-if="customFilter">
                    {{$t('orders.customFilters')}} - <a href="#" @click.prevent="resetFilters()">{{$t('orders.resetFilters')}}</a>
                  </template>
                  <template v-if="!customFilter">
                    {{$t('orders.filtersApplied')}}
                  </template>
                  <!-- <template v-for="(sts, key) in requestFilters[0].value">
                    <span class="filter-selection"> {{$t('ordersStatus.' + sts)}}<a title="Remove filter" href="#" @click.prevent="removeFilter(0, key)"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                  </template>
                  <template v-for="(sts, key) in requestFilters[1].value">
                    <span class="filter-selection">{{locations[getObjectByElemKeyValue('id', sts, locations)].name}} <a title="Remove filter" href="#" @click.prevent="removeFilter(0, key)"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                  </template> -->
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="table-container" 
              ref="tableContainerRef"
              :style="{height: windowHeight - tableTopHeight - tableBottomHeight - pageTopHeight + 'px'}">
            <data-tables class=""
                      v-loading="loading"
                      ref="detailsScrollTable"
                      :data="tableData"
                      :current-page="1"
                      :page-size="paginationDef.pageSize"
                      @row-click="goToRecord"
                      :filters="filters"
                      :table-props="{'row-class-name': rowClass, 'border': false, 'stripe': false,}"
                      style="width: 100%; background: #fff"
                      >
              <el-table-column
                :min-width="100"
                prop="price"
                label="Total Amount">
                <template slot-scope="props">
                  <div v-html="props.row.customer_display"></div>
                  <div class="location-info" v-if="showLocations">{{props.row.production_details ? props.row.production_details.location.name : ''}}</div>
                  <div><b>{{props.row.totals_grandtotal}} {{getCurrencySymbol(props.row.currency)}}</b></div>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="100"
                prop="status"
                label="Status">
                <template slot-scope="props">
                  <div class="xxs-font mar-bt-40">{{ $t('orders.the_order') }} @ {{formatDateTime(props.row.created_at)}}</div>
                  <b>{{props.row.delivery_type ? $t('deliveryTypes.' + props.row.delivery_type) : ''}}
                    <template v-if="props.row.delivery_type !== 'EAT_LOCATION'">
                      {{$t('orders.at')}} {{props.row.pickup_datetime | formatTime}}
                    </template>
                  </b>
                  <span class="label" :class="'label-' + orderStatusClass(props.row.status.id)" >{{props.row.status.type}}</span>
                </template>
              </el-table-column>
            </data-tables>
          </div>
          <div class="orders-table-bottom table-bottom" ref="tableBottom">
            {{$t('general.showing', {length: tableData.length})}}
            <a v-if="showLoadMore" class="btn btn-info btn-fill" @click.prevent="loadMore()">{{$t('general.loadMore')}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-9 col-md-8 col-xs-8 detailsScroll" ref="detailsScroll" :style="{height: windowHeight - pageTopHeight + 'px'}">
      <order-form v-if="showForm()" ref="orderForm" :showLocations="showLocations" :callback="updateList"
      ></order-form>
      <div class="no-element" v-if="!showForm()">
        <i class="shopping-cart"></i>
        <div>{{$t('orders.noOrders')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Row, Select, Option, Checkbox, CheckboxGroup, Dropdown, DropdownMenu, DropdownItem} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import OrderForm from './OrderView.vue'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  Vue.use(Row)
  Vue.use(Checkbox)
  Vue.use(CheckboxGroup)
  Vue.use(Dropdown)
  Vue.use(DropdownMenu)
  Vue.use(DropdownItem)
  export default{
    components: {
      PPagination,
      PSwitch,
      OrderForm
    },
    computed: {

    },
    created: function () {
      this.getData(false, false)

      var userData = JSON.parse(this.$session.get('userData'))
      // var companyKey = this.getObjectByElemKeyValue('company_id', this.$session.get('selectedCompany'), userData)
      // console.warn(companyKey)
      this.locations = this.$session.get('selectedCompanyData').locations_details
      if (this.locations.length > 1) {
        this.showLocations = true
      }
      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.locationFilter = filterCookie
      }
    },
    data () {
      return {
        loading: true,
        paginationDef: {
          pageSize: 99999,
          currentPage: 1,
          pageSizes: [99999],
          show: false
        },
        searchQuery: '',
        timeout: null,
        propsToSearch: ['status', 'price'],
        tableColumns: [
          {
            prop: 'number',
            label: 'Number',
            minWidth: 100
          },
          {
            prop: 'type',
            label: 'Type',
            minWidth: 100
          }
        ],
        orders: [],
        ordersReversed: [],
        useReversed: false,
        tableData: [],
        windowHeight: 0,
        tableTopHeight: 70,
        tableBottomHeight: 62,
        pageTopHeight: 0,
        initialStatuses: ['NEW', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT'],
        requestLimit: 30,
        requestPage: 1,
        customFilter: false,
        showLoadMore: false,
        requestFilters: [
          {
            value: ['NEW', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT'] // status
          },
          {
            value: [] // location
          },
          {
            value: '' // search by test
          }
        ],
        locationFilter: [],
        resetFiltersObj: [{value: ['NEW', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT']}, {value: []}, {value: ''}],
        filters: [],
        statuses: this.$session.get('defaultData')['order_statuses']['ALL_DELIVERY_TYPES'],
        locations: [],
        showLocations: false,
        heartbeatSet: false
      }
    },
    mounted () {
      this.$nextTick(() => {
        console.warn('mounted')
        this.windowHeight = window.innerHeight
        this.tableTopHeight = (this.$refs.tableTop && this.$refs.tableTop.clientHeight) ? this.$refs.tableTop.clientHeight : 0
        // console.warn(window.innerWidth)
        if (window.innerWidth < 1200) {
          this.pageTopHeight = 0// 75
        } else {
          this.pageTopHeight = 0
        }

        window.addEventListener('resize', () => {
          this.windowHeight = window.innerHeight
          this.tableTopHeight = (this.$refs.tableTop && this.$refs.tableTop.clientHeight) ? this.$refs.tableTop.clientHeight : 0
          // console.warn(window.innerWidth)
          if (window.innerWidth < 1200) {
            this.pageTopHeight = 0// 75
          } else {
            this.pageTopHeight = 0
          }
        })

        if (!this.heartbeatSet) {
          this.heartbeat()
          this.heartbeatSet = true
        }
      })
    },
    methods: {
      goToRecord (row, event, column) {
        this.globalGoToRecord(row, event, column, '/orders/view/')
        this.$refs.orderForm.getData()
      },
      heartbeat: function () {
        var self = this
        setInterval(() => {
          console.warn(self.customFilter)
          if (!self.customFilter) {
            self.getData(true, false)
          }
        }, 60000)
        setInterval(() => {
          if (self.$session.get('temp-status')) {
            self.requestFilters[0].value = [this.$session.get('temp-status')]
            self.$session.remove('temp-status')
            self.getData(true, false)
          }
        }, 1000)
      },
      getData (isHeartBeat, isLoadMore) {
        // if (this.$session.get('temp-status')) {
        //   this.requestFilters[0].value = [this.$session.get('temp-status')]
        //   this.$session.remove('temp-status')
        // }
        // console.warn(isHeartBeat)
        if (!isHeartBeat) {
          this.$nextTick(function () {
            this.loading = true
          })
        }
        var self = this
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          inactive: 1,
          limit: this.requestLimit,
          page: this.requestPage,
          sort_order: self.useReversed ? 'desc' : 'asc'
        }
        if (this.requestFilters[0].value.length) {
          data.statuses = this.requestFilters[0].value.join(',')
        }
        if (this.locationFilter.length) {
          data.location_ids = this.locationFilter.join(',')
        }
        if (this.requestFilters[2].value !== '') {
          data.search = this.requestFilters[2].value
        }
        var currentOrderId = null
        if (this.showForm()) {
          currentOrderId = parseInt(this.$route.params.id)
        }
        this.apiRequest('/order', 'GET', data, function (response) {
          if (response.status === true) {
            var goodOrders = []
            for (var idx in response.data) {
              if (response.data[idx]['status'].id === 'DRAFT') {
                // delete response.data[idx]
              } else {
                response.data[idx]['status_type'] = response.data[idx]['status'].id
                response.data[idx]['production_location'] = response.data[idx].production_details !== null ? response.data[idx].production_details.location.id : ''

                goodOrders.push(response.data[idx])

                if (isHeartBeat && currentOrderId === response.data[idx].id) {
                  if (self.$refs.orderForm) {
                    self.$refs.orderForm.heartbeat(response.data[idx])
                  }
                }
              }
              if (response.data[idx]['customer']) {
                if (response.data[idx]['customer']['firstname'] === null) {
                  if (response.data[idx]['delivery_details_firstname']) {
                    response.data[idx]['customer_display'] = '<b>' + response.data[idx]['delivery_details_firstname'] + '</b>'
                    response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['delivery_details_phone'] + '</small>'
                  } else if (response.data[idx]['delivery_details_phone']) {
                    response.data[idx]['customer_display'] = '<b>' + response.data[idx]['delivery_details_phone'] + '</b>'
                  } else if (response.data[idx]['customer']['phone']) {
                    response.data[idx]['customer_display'] = '<b>' + response.data[idx]['customer']['phone'] + '</b>'
                  }
                  if (response.data[idx]['customer']['email']) {
                    response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['customer']['email'] + '</small>'
                  }
                  response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><span class="xxs-font">Number of Orders: ' + response.data[idx]['counter_orders_per_customer'] + '</span>'
                } else if ((response.data[idx]['customer']['firstname'] !== null && response.data[idx]['customer']['lastname'] !== null) || (response.data[idx]['customer']['firstname'] !== null)) {
                  if (response.data[idx]['delivery_details_firstname']) {
                    response.data[idx]['customer_display'] = '<b>' + response.data[idx]['delivery_details_firstname'] + '</b>'
                  } else {
                    response.data[idx]['customer_display'] = '<b>' + response.data[idx]['customer']['firstname'] + ' ' + response.data[idx]['customer']['lastname'] + '</b>'
                  }
                  if (response.data[idx]['delivery_details_phone']) {
                    response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['delivery_details_phone'] + '</small>'
                  } else if (response.data[idx]['customer']['phone']) {
                    response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['customer']['phone'] + '</small>'
                  }
                  if (response.data[idx]['customer']['email']) {
                    response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['customer']['email'] + '</small>'
                  }
                  response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><span class="xxs-font">Number of Orders: ' + response.data[idx]['counter_orders_per_customer'] + '</span>'
                } else {
                  response.data[idx]['customer_display'] = 'CCC'
                }
              } else {
                response.data[idx]['customer_display'] = ''
              }
            }

            if (goodOrders.length < self.requestLimit) {
              self.showLoadMore = false
            } else {
              self.showLoadMore = true
            }

            if (isLoadMore) {
              self.orders = self.orders.concat(goodOrders)
            } else {
              self.orders = goodOrders
            }
            // self.ordersReversed = self.orders.reverse()
            // self.tableData = self.useReversed ? self.orders : self.ordersReversed
            self.tableData = self.orders

            self.paginationDef.pageSize = self.tableData.length + 1

            self.scrollToCurrent()

            self.$nextTick(function () {
              self.loading = false
            })
          }
        })
      },
      scrollToCurrent () {
        this.$nextTick(function () {
          let el = this.$el.getElementsByClassName('current')[0]
          if (el) {
            var container = this.$refs.tableContainerRef
            var table = this.$refs.detailsScrollTable.$el.querySelector('.el-table__body tbody')
            var position = 1

            for (var i = 0; i < table.children.length; i++) {
              if (table.children[i].classList.length > 1 && table.children[i].classList[1] === 'current') {
                if (i > 1) {
                  position = i
                }
              }
            }
            container.scrollTo({
              left: 0,
              top: el.clientHeight * position,
              behavior: 'smooth'
            })
          }
        })
      },
      rowClass (row, index) {
        if (this.$route.params.id && (parseInt(row.row.id) === parseInt(this.$route.params.id))) {
          return 'current row-' + this.orderStatusClass(row.row.status.id)
        } else {
          return 'row-' + this.orderStatusClass(row.row.status.id)
        }
      },
      showForm () {
        if (this.$route.path.indexOf('view') !== -1) {
          return true
        } else {
          return false
        }
      },
      removeFilter (filterKey, key) {
        if (filterKey === 0) {
          Vue.delete(this.requestFilters[filterKey].value, key)
        } else {
          Vue.delete(this.filters[filterKey].value, key)
        }
        this.tableTopHeight = this.$refs.tableTop.clientHeight
        this.updateCookie()
      },
      resetFilters () {
        this.customFilter = false
        this.requestPage = 1
        var filter = this.resetFiltersObj
        this.requestFilters = filter
      },
      loadMore () {
        this.customFilter = true
        this.requestPage = this.requestPage + 1
        this.getData(false, true)
      },
      updateCookie () {
        console.warn(this.locationFilter)
        this.$cookie.set('filter-locations', JSON.stringify(this.locationFilter), 1)
        this.requestPage = 1
        this.getData(false, false)
      },
      updateList (id, status) {
        let idx = this.getObjectByElemKeyValue('id', parseInt(id), this.tableData)

        if (idx) {
          this.tableData[idx]['status'] = status
          this.tableData[idx]['status_type'] = status['type']
        }
      },
      search () {
        // clear timeout variable
        clearTimeout(this.timeout)

        var self = this
        this.timeout = setTimeout(function () {
          // enter this block of code after 1 second
          // handle stuff, call search API etc.
          console.log('searching:', self.searchQuery)
          self.requestFilters[2].value = self.searchQuery
        }, 500)
      }
    },
    watch: {
      requestFilters: {
        handler: function (newval, oldval) {
          let self = this
          let onlyDefaults = newval[0]['value'].filter(function (elm) {
            return self.resetFiltersObj[0]['value'].indexOf(elm) === -1
          })

          let rev = false
          if (newval[2]['value'] === '' && (
                (newval[0]['value'].length === 6 && onlyDefaults) ||
                (newval[0]['value'].length === 1 && newval[0]['value'][0] === 'NEW') ||
                (newval[0]['value'].length === 1 && newval[0]['value'][0] === 'PROCESSING'))
          ) {
            this.customFilter = false
            rev = false
          } else {
            this.customFilter = true
            rev = true
          }
          this.useReversed = rev

          this.requestPage = 1
          this.getData(false, false)

          // do something when the data changes.
          /*
          let all = newval[0]['value']
          let rev = false
          if (all.length === 0) {
            rev = true
          } else {
            for (var i in all) {
              if (!this.initialStatuses.includes(all[i])) {
                rev = true
              }
            }
          }
          */

          // this.tableData = this.useReversed ? this.orders : this.ordersReversed
          // this.tableData = this.useReversed ? this.ordersReversed : this.orders

          this.paginationDef.pageSize = this.tableData.length + 1
        },
        deep: true
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Orders/Orders.vue